module.exports = __webpack_public_path__ + "img/EhsDonutStatus.f53f468f.png";